let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l8VWt")).then(() => parcelRequire('lJB7m'));